import { Page } from "@/models/page-models/Page";

export const Users: Page = {
  "path": "users",
  "name": "Users",
  "props": {
    "data": {
      "title": "Users",
      "printable": "FALSE",
      "url": "users",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Users",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "User Id"
                    },
                    {
                      "value": "__item.displayName",
                      "text": "Display Name"
                    },
                    {
                      "value": "__item.emails.0.value",
                      "text": "Email"
                    },
                    {
                      "value": "__item.role",
                      "text": "Roles",
                      "formula": "fn(HELPER_FN,joinArray,{{__item.role}})"
                    },
                    {
                      "value": "__item.lastSeen",
                      "text": "Last Seen",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.lastSeen}})"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions",
                      "type": "actions",
                      "width": 180,
                      "actions": [
                        {
                          "label": "Change Role",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copysUserName"
                            },
                            {
                              "executionOrder": 2,
                              "name": "copyUserDetails"
                            },
                            {
                              "executionOrder": 3,
                              "name": "openRolePopup"
                            }
                          ]
                        },
                        {
                          "label": "Force Logout",
                          "priority": "menu",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "forceLogoutUser"
                            }
                          ]
                        },
                        {
                          "label": "Delete User",
                          "priority": "menu",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "deleteUser",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/users/{{__item._id}}/delete",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "DELETE"
                              },
                              "name": "deleteUser"
                            }
                          ]
                        }
                      ],
                      "useMenu": true
                    },
                    {
                      "value": "__item.isAdmin",
                      "text": "Admin"
                    },
                    {
                      "value": "__item.isDeleted",
                      "text": "Deleted"
                    }
                  ],
                  "tableType": "static",
                  "showActions": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Change Role",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.name",
                  "label": "Name",
                  "labelType": "formula",
                  "formula": "{{fetchedData.selectedUser.userName}}"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "checkboxGroup",
                  "variable": "formData.role",
                  "disabled": "FALSE",
                  "items": "fetchedData.roles"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Clear Roles",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "clearRoles"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "changeRole"
                },
                {
                  "executionOrder": 2,
                  "name": "closeRolePopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getUsers"
      },
      {
        "executionOrder": 1,
        "name": "getRoles"
      }
    ],
    "functions": [
      {
        "name": "getUsers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/users/find-all",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.users"
      },
      {
        "name": "getRoles",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/users/roles",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.roles"
      },
      {
        "name": "copyUserDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getUserDetails",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "copysUserName",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedUser"
      },
      {
        "name": "getUserDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{fetchedData.selectedUser._id}}",
          "role": "{{fetchedData.selectedUser.role}}",
          "changeActiveRole": "{{1==1}}"
        },
        "useFormula": true
      },
      {
        "name": "openRolePopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Change Role"
      },
      {
        "name": "closeRolePopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Change Role"
      },
      {
        "name": "changeRole",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/users/initializeRole",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "clearRoles",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "resetRolesArray",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "resetRolesArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "role": "[]"
        },
        "useFormula": true
      },
      {
        "name": "forceLogoutUser",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/users/{{__item._id}}/force-logout",
        "arg2Key": "formData",
        "arg2Value": "\"{}\"",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      }
    ]
  },
  "forRole": "SYSTEM_ADMIN",
  "visible": true
}